import {HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr} from '@angular/common/http';
import {DOCUMENT, inject, NgModule, provideAppInitializer} from '@angular/core';
import {EMPTY, Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {AppConfigService} from '../../services/config.service';
import svgSpriteFileMap from './svg-sprite-file-map.json';

function initializeAppFactory(httpClient: HttpClient, appConfigService: AppConfigService, document: Document): () => Observable<unknown> {
    const spriteUrl = appConfigService.getPublicPath(`assets/images/${svgSpriteFileMap['icons-sprite.svg']}`);

    return () => httpClient.get(spriteUrl, {responseType: 'text'})
        .pipe(
            tap(svgStr => {
                document.body.insertAdjacentHTML('afterbegin', svgStr);
            }),
            catchError(error => {
                console.error('Error while loading SVG Sprite.', error);

                return EMPTY;
            })
        );
}

@NgModule({
    imports:   [],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = initializeAppFactory(
                inject(HttpClient),
                inject(AppConfigService),
                inject(DOCUMENT)
            );

            return initializerFn();
        }),
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
})
export class SvgSpriteModule {}
